import {STOKKE_DEVELOPMENT_LOG} from '../constants'
import {isServer} from './utils'

/*
 * This is a logger utility that can be used to log messages to the console. It
 * will only log messages if the environment is a server or the local storage
 * have `stokke-development-log` key set to enable logging.
 */
const logger = class {
    /**
     * @returns {boolean}
     */
    static isEnabled() {
        return Boolean(isServer || global?.localStorage?.[STOKKE_DEVELOPMENT_LOG])
    }

    /**
     * @param {...any} args
     */
    static debug(...args) {
        if (logger.isEnabled) {
            console.debug(...args)
        }
    }

    /**
     * @param {...any} args
     */
    static log(...args) {
        if (logger.isEnabled) {
            console.log(...args)
        }
    }

    /**
     * @param {...any} args
     */
    static info(...args) {
        if (logger.isEnabled) {
            console.info(...args)
        }
    }

    /**
     * @param {...any} args
     */
    static warn(...args) {
        if (logger.isEnabled) {
            console.warn(...args)
        }
    }

    /**
     * @param {...any} args
     */
    static error(...args) {
        if (logger.isEnabled) {
            console.error(...args)
        }
    }
}

export default logger
